export enum ProductTypesEnum {
  goods = 'GOODS',
  services = 'SERVICES',
}

export interface ProductInterface {
  id: number
  code?: string | null // Either null or a non-empty string
  name: string
  description?: string
  unit: string
  vatPct: number // Percentage using 0.xx notation
  total?: number // Total required if using TOTAL pricing model
  price?: number // Price required if using PRICE pricing model
  pricingModel: 'PRICE' | 'TOTAL'
  category?: 'WORK' | 'GOODS' // Falls back to GOODS if omitted
  productType?: ProductTypesEnum
  vatRateId?: string
}

export type ProductForImportInterface = Omit<ProductInterface, 'id' | 'code' | 'pricingModel' | 'category'>
